import { render, staticRenderFns } from "./GameLayout.vue?vue&type=template&id=ee04c07a&scoped=true"
import script from "./GameLayout.vue?vue&type=script&lang=js"
export * from "./GameLayout.vue?vue&type=script&lang=js"
import style0 from "./GameLayout.vue?vue&type=style&index=0&id=ee04c07a&prod&lang=scss"
import style1 from "./GameLayout.vue?vue&type=style&index=1&id=ee04c07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee04c07a",
  null
  
)

export default component.exports